// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__d3Os+","header":"Quiz_header__HCD8U","card":"Quiz_card__9KRNp","field":"Quiz_field__2A4eU","option":"Quiz_option__3nwEm"};